import { html, TemplateResult } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './idb-bar-graph-panel.css.lit';
import { classMap } from 'lit/directives/class-map.js';

/**The IDB bar graph panel component.
 * @element idb-bar-graph-panel
 */

@customElement('idb-bar-graph-panel')
export class BarGraphPanel extends OutlineElement {
  static styles = [componentStyles];

  /**
   * Whether the bar has the active class.
   */
  @property({ type: Boolean, reflect: true, attribute: true })
  active = false;

  /**
   * The text to display in the graph bar.
   */
  @property({ type: String, attribute: 'graph-text' })
  graphText: string;

  /**
   * The numeric text to display in the bar graph.
   */
  @property({ type: String, attribute: 'graph-number' })
  graphNumber: number;

  /**
   * The class of the bar graph.
   */
  @property({ type: String, attribute: 'graph-class' })
  graphClass: string;

  /**
   * The width of the bar.
   */
  @property({ type: Number, attribute: 'bar-width' })
  barWidth: number;

  render(): TemplateResult {
    this.barWidth = this.barWidth > 100 ? 100 : this.barWidth;

    return html`
      <div class="${classMap({
        [this.graphClass]: true,
        'bar-graph-panel': true,
        'bar-graph-panel--active': this.active,
      })}"
        @click=${this.setActive}
      >
        <div class="bar-graph-panel--text-container">
          <p class="bar-graph-panel--text">${this.graphText}</p>
          <p class="bar-graph-panel--number">${this.graphNumber}</p>
        </div>
        <div class="bar-graph-panel--bar-container">
          <div class="bar-graph-panel--bar" style="width:${
            this.barWidth
          }%;"></div>
        </div>
      </div>
    `;
  }

  setActive() {
    this.active = !this.active;
  }
}
